export default "__VITE_ASSET__BUdi9hgY__"